// react_frontend/src/Components/Layouts/Master.js
import React from 'react'
import Footer from "../../Components/Partials/Footer";
import Navber from "../../Components/Partials/Navber";
import Sidebar from "../../Components/Partials/Sidebar";
import { Outlet } from "react-router-dom";
import $ from 'jquery';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Master = () => {
  useScrollToTop();
  const handleSidebar = () => {
    $('body').removeClass('sb-sidenav-toggled')
  }

  return (
    <>
      <Navber />
      <Sidebar />
      <div id="layoutSidenav">
        <div id="layoutSidenav_content" onClick={() => handleSidebar()}>
          <main>
            <div className="container-fluid px-2">
              <Outlet />
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default Master